(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/track/reports/betoTrackReports.tpl.html',
    '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12 mainContent" style="padding: 2px"><div ui-view="vehicleDetail" ng-show="$state.includes(\'reports.vehicleDetail\')"></div><div ui-view="groupDetail" ng-show="$state.includes(\'reports.groupDetail\')"></div><div ui-view="groupSummary" ng-show="$state.includes(\'reports.groupSummary\')"></div><div ui-view="performance" ng-show="$state.includes(\'reports.performance\')"></div></div></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/track/reports/betoTrackReports.tpl.js